/**
 * Global getter for the current layout snapshot. Installed by the
 * managed-layout provider when the host boots in managed mode; `null`
 * (or unset) in compat mode and headless entries.
 *
 * `buildChildPayload` calls this to seed every nested child's
 * `AppContext.layout`, so each child's `host.layout.snapshot` has the
 * right initial value at boot — without the child needing to make a
 * round-trip to the host.
 *
 * The returned value is the Wippy-flavored `HostLayoutDeclaration`
 * shape (typed as `unknown` here to avoid a types-circular dep between
 * `@shared/app-config` and `@features/layout`).
 */
let getter: (() => unknown) | null = null

export function setLayoutSnapshotGetter(fn: (() => unknown) | null) {
  getter = fn
}

export function getLayoutSnapshot(): unknown {
  return getter?.() ?? null
}
